var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBlueBoat = function SvgBlueBoat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 108,
    viewBox: "0 0 164 108",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7204 71.2012L0 50.2154L55.3792 48.4665L43.7204 71.2012Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7887 0.237915L22.928 68.5887L81.7887 88.7051V0.237915Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.332 70.6184L106.678 47.8838L163.223 45.552L125.332 70.6184Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5322 90.2093L81.7583 1.01574L132.306 73.2073L91.5006 96.1717L81.5322 90.2093Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0289 0.805145L22.1683 69.1559L81.0289 89.2723V0.805145Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2504 98.414L0.777222 51.1475L77.1331 62.0834L164 46.484L146.715 94.1035L80.2119 107.651L19.2504 98.414Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2504 98.414L0.777222 51.1475L77.1331 62.0834L164 46.484L146.715 94.1035L80.2119 107.651L19.2504 98.414Z",
    fill: "url(#blue_boat_paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4732 97.636L0 50.3695L76.3558 61.3054L163.223 45.706L145.938 93.3256L79.4347 106.873L18.4732 97.636Z",
    fill: "url(#blue_boat_paint7_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 11,
    y1: 39.5874,
    x2: 41.5,
    y2: 64.0874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43AFDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 69.3675,
    y1: -25.4107,
    x2: 70.5333,
    y2: 161.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557327,
    stopColor: "#43AFDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 151,
    y1: 45.5874,
    x2: 115.5,
    y2: 57.5874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43AFDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 100.5,
    y1: 0.587394,
    x2: 59,
    y2: 275.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#D0EBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43AFDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 64,
    y1: 44.5874,
    x2: 5.24646,
    y2: -25.9933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 82.3863,
    y1: 10.4968,
    x2: 82.3863,
    y2: 91.7173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC8387"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blue_boat_paint6_linear",
    x1: 82.3863,
    y1: 25.6528,
    x2: 82.3863,
    y2: 136.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885417,
    stopColor: "#43AFDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blue_boat_paint7_linear",
    x1: -100.068,
    y1: 69.9944,
    x2: 231.031,
    y2: 69.6058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0EBF6"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlueBoat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blue_boat.edaaa2d0.svg";
export { ForwardRef as ReactComponent };